<div class="layout">
    @if(!unauthorizedUser){
    <app-top-bar></app-top-bar>
    }

    <div class="container-fluid">
        <router-outlet></router-outlet>
    </div>

</div>